// App.js
import { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";
import NoticeBoard from "./components/NoticeBoard";
import PopupBoard from "./components/PopupBoard";
import './App.css';
import CmsApp from './cms/CmsApp';
import { apiAxios, apiAxiosMulti } from "./cms/api/mockApi";

const sessionKey = "__manhattancafe__";

// 체류시간 저장 API
const STAY_TIME_UPDATE_URL = "/scms/api/sts/insertVisitInfo.do";
// 체류시간 주기 전송 간격: 30초
const STAY_TIME_INTERVAL = 30000;

/* 좌측 퀵메뉴 노출 섹션 */
const SECTIONS = [
  { id: 'top',       label: 'Top',  img: 'top.png' },
  { id: 'about',     label: '회사소개',  img: 'about.png' },
  { id: 'history',   label: '연혁',      img: 'history.png' },
  { id: 'business',  label: '사업소개',  img: 'business.png' },
  { id: 'solutions', label: '솔루션',    img: 'solution.png' },
  { id: 'cloud',     label: '클라우드',  img: 'cloud-service.png' },
  { id: 'notice',    label: '공지사항',  img: 'notice.png' },
  { id: 'recruit',   label: '채용',      img: 'recruit.png' },
  { id: 'contact',   label: '문의',      img: 'inquire.png' }, 
];

/* 솔루션 상세 데이터 (기존 4종) */
const SOL_DETAILS = [
  {
    key: 'yes',
    title: 'YES CARE',
    sub: '재가장기요양 업무관리 프로그램',
    img: '/images/solution1.png',
    summary:
      '요양센터의 업무를 신속 정확하게 효율적으로 운영할 수 있도록 도와드리는 시스템',
    badges: ['일정관리 시스템', '현장 사용성 강화'],
    features: {
      특징: [
        '현장 중심 화면 구성·업무 흐름 자동화',
        '모바일 연계로 외부/방문 기록 간편',
        '다양한 출력물·통계 제공',
      ],
      주요기능: [
        '수급자/요양보호사 관리',
        '일정/근태/급여/청구 관리',
        '일지/방문기록/각종 출력물',
      ],
    },
  },
  {
    key: 'scms',
    title: 'SCMS 웹 콘텐츠 관리시스템',
    img: '/images/solution2.png',
    summary:
      '전자정부표준프레임워크 기반의 웹 콘텐츠 관리시스템으로써 웹사이트 운영을 효율적으로 관리할 수 있는 시스템',
    badges: ['전자정부표준프레임워크', 'TTA GS 인증'],
    features: {
      특징: [
        '표준 기반 구조로 안정성·확장성 우수',
        '권한/메뉴/콘텐츠/게시판/폼 통합관리',
        '작업 이력·승인 흐름으로 거버넌스 강화',
      ],
      주요기능: [
        '페이지/게시판/메인화면/콘텐츠 관리',
        '사용현황/사용자/사용자권한 관리',
        '프로그램/메뉴/코드 관리',
      ],
    },
  },
  {
    key: 'lib',
    title: '통합 도서일지 프로그램',
    img: '/images/solution3.png',
    summary:
      '도서관 운영에 필요한 일지관리를 통합으로 관리할 수 있도록 지원하는 시스템',
    badges: ['통합검색/이용자 포털', 'TTA GS 인증'],
    features: {
      특징: [
        '대출/반납/예약/연체 자동 처리',
        '소장·수서·정리 연계',
        '운영 지표/통계 리포트',
      ],
      주요기능: [
        '개관일/전자도서관/DVD 현황 관리',
        '대출현황/회원증 발급 365 책바다 현황 관리',
        '이용인원 현황/이용자료 현황/상호대차 현황 관리',
      ],
    },
  },
  {
    key: 'deposit',
    title: '영구임대보증금 지원관리 시스템',
    img: '/images/solution4.png',
    summary:
      '영구임대주택 신규 입주자 중 장애인 등 요건 해당  세대에 대하여 임대보증금을 지원하는 업무관리 시스템',
    badges: ['데이터 정합성 강화', '업무 투명성 확보'],
    features: {
      특징: [
        '대상자 중심 관리(신청·자격·지원내역)',
        '현황/통계 시각화(차트로 직관적 분석)',
        '수납 프로세스 연계(수납의뢰→수납처리→과오납)',
      ],
      주요기능: [
        '대상자 관리/대상자별 종합현황',
        '수납의뢰/수납처리 및 자료등록',
        '각종 통계 데이터/과오납 관리',
      ],
    },
  },
  {
    key: 'aiwater',
    title: '배수지 공급량 예측시스템',
    img: '/images/solution5.png',
    summary:
      '배수지의 과거 유량·수요 등 데이터를 학습해 시간대별 공급량을 예측하고, 운영 의사결정을 지원하는 AI 기반 시스템',
    badges: ['데이터 AI/ML 예측모델', '운영 대시보드'],
    features: {
      특징: [
        'AI 예측(과거 유량·수요·환경)',
        '모델/학습데이터/예측결과 관리',
        '시뮬레이션 및 임계치 경보 설정'
      ],
      주요기능: [
        '모델(회귀/시계열 등)/데이터 버전 관리',
        '모델 성능지표 비교·최적 모델 선정',
        '예측결과 시각화·리포트/CSV'
      ],
    },
  },
];


function AppHome() {
  const [sessionId, setSessionId] = useState(null);
  const [activeSection, setActiveSection] = useState('about');
  // const [sol, setSol] = useState(SOL_DETAILS[0]);

  useEffect(() => {
    const onScroll = () => {
      // 상단 근처에서는 항상 top을 active로 유지
      if (window.scrollY < 40) {
        if (activeSection !== 'top') setActiveSection('top');
        return;
      }

      const mid = window.innerHeight / 2;
      let bestId = SECTIONS[0].id;
      let bestDist = Infinity;

      for (const s of SECTIONS) {
        const el = document.getElementById(s.id);
        if (!el) continue;
        const r = el.getBoundingClientRect();
        const dist = Math.abs((r.top + r.height / 2) - mid);
        if (dist < bestDist) {
          bestDist = dist;
          bestId = s.id;
        }
      }
      setActiveSection(bestId);
    };

    // 최초에도 호출해서 올바르게 맞춰놓기
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [activeSection]);

  // 신규 세션 생성 + 기존 세션도 state에 반영
  useEffect(() => {
    let savedSessionId = window.sessionStorage.getItem(sessionKey);

    if (savedSessionId === null) {
      savedSessionId = Math.random().toString(36).substring(2, 12);
      window.sessionStorage.setItem(sessionKey, savedSessionId);
    }

    setSessionId(savedSessionId);
  }, []);

  // 방문 정보 저장
  useEffect(() => {
    if (sessionId !== null) {
      const url = "/scms/api/sts/insertVisitInfo.do";
      const body = JSON.stringify({
        AGENT: navigator.userAgent,
        SESSIONID: sessionId,
      });

      apiAxios(url, body, function (res) {
        if (res?.apiRes === "N") {
          console.error("[방문정보 저장 실패]", res.message);
        }
      });
    }
  }, [sessionId]);

  // 체류시간 계산 및 서버 전송
  useEffect(() => {
    if (!sessionId) return;

    const visitStartTime = Date.now();
    let lastSentStaySeconds = 0;

    // 현재까지 체류시간 계산
    const getStaySeconds = () => {
      return Math.max(0, Math.round((Date.now() - visitStartTime) / 1000));
    };

    // 서버로 보낼 데이터 생성
    const makeStayPayload = (eventType = "HEARTBEAT") => {
      const staySeconds = getStaySeconds();

      return {
        AGENT: navigator.userAgent,
        SESSIONID: sessionId,
        STAY_SECONDS: staySeconds,
        EVENT_TYPE: eventType,
        LAST_ACTIVE_DT: new Date().toISOString(),
      };
    };
    // 일반 주기 전송
    const sendStayTime = (eventType = "HEARTBEAT") => {
      const payload = makeStayPayload(eventType);

      // 같은 초를 중복 전송하지 않도록 방지
      if (payload.STAY_SECONDS <= lastSentStaySeconds) return;

      lastSentStaySeconds = payload.STAY_SECONDS;

      const body = JSON.stringify(payload);

      //console.log("[체류시간 전송]", payload);

      /*apiAxios(STAY_TIME_UPDATE_URL, body, function (res) {
        if (res?.apiRes === "N") {
          console.error("[체류시간 저장 실패]", res.message);
        }
      });*/
    };

    // 페이지 종료/숨김 시 최종 전송
    const sendStayTimeByBeacon = (eventType = "PAGE_HIDE") => {
      const payload = makeStayPayload(eventType);

      if (payload.STAY_SECONDS <= lastSentStaySeconds) return;

      lastSentStaySeconds = payload.STAY_SECONDS;

      console.log("[체류시간 최종 전송]", payload);

      const body = JSON.stringify(payload);

      if (navigator.sendBeacon) {
        const blob = new Blob([body], {
          type: "application/json",
        });

        navigator.sendBeacon(STAY_TIME_UPDATE_URL, blob);
      } else {
        fetch(STAY_TIME_UPDATE_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body,
          keepalive: true,
        }).catch((e) => {
          console.error("[체류시간 최종 전송 실패]", e);
        });
      }
    };

    // 30초마다 체류시간 저장
    const timer = window.setInterval(() => {
      sendStayTime("HEARTBEAT");
    }, STAY_TIME_INTERVAL);

    // 탭이 백그라운드로 가거나 닫힐 때
    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        sendStayTimeByBeacon("VISIBILITY_HIDDEN");
      }
    };

    // 페이지 이동/닫기
    const onPageHide = () => {
      sendStayTimeByBeacon("PAGE_HIDE");
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("pagehide", onPageHide);

    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("pagehide", onPageHide);

      // React unmount 시 마지막 전송
      sendStayTimeByBeacon("UNMOUNT");
    };
  }, [sessionId]);


  const handleQuickClick = (e, id) => {
    e.preventDefault();
    setActiveSection(id);
    const el = document.getElementById(id);
    if(el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start'});
    }
  }

  // ===================== 프로젝트 문의 ========================
  // 문의 입력값 상태
  const [userNm, setUserNm] = useState("");  // 성함
  const [comNm,  setComNm]  = useState("");  // 회사명
  const [email,  setEmail]  = useState("");  // 이메일
  const [msg,    setMsg]    = useState("");  // 문의내용
  const [bbsId,  setBbsId]  = useState("BBSMSTR_BBBBBBBBBBBB");  // 게시판 종류

  // UI 상태
  const [busy, setBusy] = useState(false);
  const [err,  setErr]  = useState("");
  const [ok,   setOk]   = useState("");

  // 간단 검증
  const validate = () => {
    if (!userNm.trim()) return "성함을 입력해 주세요.";
    if (!email.trim())  return "이메일을 입력해 주세요.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return "이메일 형식을 확인해 주세요.";
    if (!msg.trim())    return "문의내용을 입력해 주세요.";
    return "";
  };

  // 전송 (API 호출 제외, 검증 + payload만 구성)
  const onSubmit = (e) => {
    e.preventDefault();
    if (busy) return;
    const reason = validate();
    if (reason) {
      setErr(reason);
      setOk("");
      return;
    }
    setBbsId("BBSMSTR_BBBBBBBBBBBB");
    setBusy(true);
    setErr("");
    setOk("");
    const url = "/scms/api/bbs/insertBoardArticle.do";
    const body = JSON.stringify({
      USER_NM: userNm.trim(),
      COM_NM:  comNm.trim(),
      NTCR_ID:   email.trim(),
      NTT_CN:  msg.trim(), // 내용
      NTT_SJ:  "", // 제목
      REG_DT:  new Date().toISOString(), // 선택
      BBS_ID:  bbsId,
    });
    const requestBody = new FormData();
    const info = new Blob([body], { type: 'application/json' });
    requestBody.append("info", info);
    
    apiAxiosMulti(url, requestBody, function(res) {
      if(res.apiRes === "Y") {
        setOk("문의가 정상적으로 접수되었습니다.");
        // 필요 시 초기화
        setUserNm(""); setComNm(""); setEmail(""); setMsg("");
      } else {
        setErr(res.message);
      }
    });
    setBusy(false);
  };
  // ==============================================================


  return (
    <>
      <PopupBoard />
      {/* NAV: ‘문의하기’만 */}
      <nav className="navbar navbar-expand-lg bg-white sticky-top shadow-sm">
        <div className="container">
          <a className="navbar-brand fw-bold d-flex align-items-center" href="#top">
            <img src="./images/logo.png" alt="SSCNS" style={{height:'30px'}}/>
          </a>
          <div className="ms-auto">
            <a className="btn btn-primary rounded-pill px-4" href="#contact">
              <img
                src={`/icon/inquire.png`}
                className="inquire-icon"
                width={"18px"}
                height={"18px"}
                alt=""
                aria-hidden="true"
              />
              문의하기
            </a>
          </div>
        </div>
      </nav>

      {/* 좌측 퀵메뉴 */}
      <nav className="quick-nav d-none d-lg-block" aria-label="퀵 메뉴">
        <ul className="list-unstyled m-0">
          {SECTIONS.map(s => (
            <li key={s.id} className="q-li">
              <a
                href={`#${s.id}`}
                onClick={(e) => handleQuickClick(e, s.id)}

                className={`q-item ${activeSection === s.id ? 'active' : ''} cursorable`}
                aria-current={activeSection === s.id ? 'page' : undefined}
                title={s.label}
              >
                <img
                  src={`/icon/${s.img}`}
                  className="q-icon"
                  width={22}
                  height={"auto"}
                  alt=""            // 장식용이면 빈 alt
                  aria-hidden="true"
                />
              </a>
              <span className="label">{s.label}</span>
            </li>
          ))}
        </ul>
      </nav>



      {/* ===== HERO (배경이미지형) ===== */}
      <header id="top" className="hero-visual">
        {/* 배경 이미지 + 틴트 오버레이 */}
        <div className="hero-bg" aria-hidden="true"></div>
        <div className="hero-overlay" aria-hidden="true"></div>

        <div className="container">
          <div className="row min-vh-60 min-vh-lg-75 align-items-center gy-4">
            {/* 왼쪽 카피 + CTA */}
            <div className="col-12 col-lg-7">
              <span className="eyebrow text-white-50">Cloud · Data · Security</span>
              <h1 className="display-4 display-lg-3 fw-bolder text-white lh-tight mb-3">
                신뢰와 기술로 완성하는<br />스마트 비즈니스
              </h1>
              <p className="lead text-white-50">
                데이터·클라우드·AI 기반 디지털 혁신. <b className="text-white">성산씨엔에스</b>가
                설계부터 운영까지 함께합니다.
              </p>
              <div className="d-flex gap-2 mt-3">
                <a href="#solutions" className="btn btn-primary btn-lg rounded-pill">
                  솔루션 보러가기
                </a>
                <a href="#contact" className="btn btn-outline-light btn-lg rounded-pill inquire-btn">
                  <img
                    src={`/icon/inquire.png`}
                    className="inquire-icon"
                    width={"18px"}
                    height={"18px"}
                    alt=""
                    aria-hidden="true"
                  />
                  문의하기
                </a>
              </div>
            </div>

            {/* 오른쪽 하이라이트 카드(선택요소: 없애도 됨) */}
            <div className="col-12 col-lg-5 d-none d-lg-block">
              <div className="hero-sidecard soft-card p-4">
                <ul className="list-unstyled mb-0 text-white-75">
                  <li className="d-flex align-items-start gap-2 mb-2">
                    <img
                      src={`/icon/check.png`}
                      width={"18px"}
                      height={"18px"}
                      alt=""
                      aria-hidden="true"
                    />
                    클라우드 전환/운영 & 보안 컨설팅
                  </li>
                  <li className="d-flex align-items-start gap-2 mb-2">
                    <img
                      src={`/icon/check.png`}
                      width={"18px"}
                      height={"18px"}
                      alt=""
                      aria-hidden="true"
                    />
                    인프라 설계·구축·자동화 (IaC)
                  </li>
                  <li className="d-flex align-items-start gap-2">
                    <img
                      src={`/icon/check.png`}
                      width={"18px"}
                      height={"18px"}
                      alt=""
                      aria-hidden="true"
                    />
                    데이터 거버넌스/품질관리 컨설팅
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* 회사소개 */}
      <section id="about" className="py-5">
        <div className="container">
          <h2 className="h2 fw-bold mb-2">회사소개</h2>
          <p className="text-secondary mb-4 subTitle">
            성산씨엔에스는 인프라 구축부터 클라우드, 데이터, 보안 컨설팅까지
            고객 비즈니스에 최적화된 통합 IT 서비스를 제공합니다.
          </p>

          <div className="row g-4 align-items-stretch">
            <div className="col-12 col-lg-7">
              <div className="soft-card p-4 p-lg-5 greeting h-100">
                <h3 className="h4 fw-bold mb-3">인사말</h3>

                <p className="mb-2">
                  <strong>(주)성산씨엔에스 홈페이지를 방문해 주신 여러분 환영합니다.</strong>
                </p>

                <p className="text-secondary mb-2 intro">
                  빠르게 변하는 시대, 우리는 더 나은 선택을 위해 끊임없이 배우고 도전합니다. <br/>
                  2012년 창립 이후 인프라·클라우드·보안·데이터 분야의 역량을 축적하며 <br/>
                  고객의 문제를 최소화하고 목표 달성에 집중해 왔습니다.
                </p>

                <p className="text-secondary mb-2 intro">
                  성산씨엔에스는 신뢰와 전문성을 바탕으로 기획부터 구축·운영까지 <br/>
                  전 과정을 책임지며, 최고의 파트너가 될 것을 약속드립니다.<br/>
                  저희 (주)성산씨엔에스에 관심 가져주신 고객과 파트너사에 진심으로 감사드립니다.
                </p>

                <div className="mt-3 fw-semibold intro">
                  (주)성산씨엔에스 임직원일동
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-5">
              <div className="d-grid gap-3 about-aside">
                <div className="soft-card p-3 h-100">
                  <div className="h3 mb-2">
                    <img
                      src={`/icon/intro1.png`}
                      width={"35px"}
                      height={"auto"}
                      alt=""
                      aria-hidden="true"
                    />
                  </div>
                  <div className="fw-bold">신뢰 기반 파트너십</div>
                  <div className="text-secondary">장기 운영 경험과 레퍼런스로 안정적인 서비스를 보장합니다.</div>
                </div>

                <div className="soft-card p-3 h-100">
                  <div className="h3 mb-2">
                    <img
                      src={`/icon/intro2.png`}
                      width={"35px"}
                      height={"auto"}
                      alt=""
                      aria-hidden="true"
                    />
                  </div>
                  <div className="fw-bold">엔지니어링 역량</div>
                  <div className="text-secondary">온프레미스/클라우드 혼합 환경의 설계·구축·자동화 노하우.</div>
                </div>

                <div className="soft-card p-3 h-100">
                  <div className="h3 mb-2">
                    <img
                      src={`/icon/intro3.png`}
                      width={"35px"}
                      height={"auto"}
                      alt=""
                      aria-hidden="true"
                    />
                  </div>
                  <div className="fw-bold">비즈니스 임팩트</div>
                  <div className="text-secondary">운영 효율/보안/비용 최적화로 고객 KPI 개선에 집중합니다.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
                

      {/* 회사연혁 */}
      <section id="history" className="py-5 bg-light">
        <div className="container">
          <h2 className="h2 fw-bold mb-2">회사연혁</h2>
          <p className="text-secondary mb-4 subTitle">주요 연혁과 성과를 한눈에 확인하세요.</p>

          <ul className="timeline list-unstyled">
            {/* 2020~2023 */}
            <li>
              <div className="dot">
                <img
                  src={`${process.env.PUBLIC_URL}/icon/history1.png`}
                  alt=""
                  aria-hidden="true"
                  className="dot-icon"
                />
              </div>
              <div className="content">
                <div className="year">2020 ~ 2023</div>
                <ul className="text-secondary mb-0 ps-3">
                  <li>교육플랫폼 공동개발 협약</li>
                  <li>카카오 클라우드 협력업체</li>
                  <li>광주광역시장 표창 수여</li>
                  <li>NHN Cloud MSP 체결</li>
                </ul>
              </div>
            </li>

            {/* 2018~2019 */}
            <li>
              <div className="dot">
                <img
                  src={`${process.env.PUBLIC_URL}/icon/history2.png`}
                  alt=""
                  aria-hidden="true"
                  className="dot-icon"
                />
              </div>
              <div className="content">
                <div className="year">2018 ~ 2019</div>
                <ul className="text-secondary mb-0 ps-3">
                  <li>성산드론교육원 창립</li>
                  <li>비디오물 제작업 등록</li>
                  <li>기술혁신형 중소기업(INNO-BIZ) 확인</li>
                  <li>주 사업자 부설 드론 교육원 설립</li>
                  <li>여성기업 확인</li>
                </ul>
              </div>
            </li>

            {/* 2015~2017 */}
            <li>
              <div className="dot">
                <img
                  src={`${process.env.PUBLIC_URL}/icon/history3.png`}
                  alt=""
                  aria-hidden="true"
                  className="dot-icon"
                />
              </div>
              <div className="content">
                <div className="year">2015 ~ 2017</div>
                <ul className="text-secondary mb-0 ps-3">
                  <li>특허 획득 (휴대단말기 및 인터페이스 제어)</li>
                  <li>GS인증 획득 (도서관통합일지 솔루션)</li>
                  <li>특허 획득 (무선단말기를 이용한 전자투표)</li>
                  <li>벤처기업 인증 / GS인증</li>
                  <li>광주·전남지방중소기업청 여성기업 인증</li>
                  <li>기술혁신형 중소기업(INNO-BIZ) 선정</li>
                </ul>
              </div>
            </li>

            {/* 2012~2014 */}
            <li>
              <div className="dot">
                <img
                  src={`${process.env.PUBLIC_URL}/icon/history4.png`}
                  alt=""
                  aria-hidden="true"
                  className="dot-icon"
                />
              </div>
              <div className="content">
                <div className="year">2012 ~ 2014</div>
                <ul className="text-secondary mb-0 ps-3">
                  <li>(주)성산씨엔에스 창립</li>
                  <li>소프트웨어 사업자 등록</li>
                  <li>재가장기요양관리 프로그램 개발</li>
                  <li>정보통신 공사업 등록</li>
                  <li>IBM 소프트웨어 파트너 등록</li>
                  <li>서울사무소 개소</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </section>



      {/* 사업소개 (확장 버전) */}
      <section id="business" className="py-5">
        <div className="container">
          <h2 className="h2 fw-bold mb-2">사업소개</h2>
          <p className="text-secondary mb-4 subTitle">
            고객 환경에 맞춘 시스템 구축과 운영, 컨설팅을 제공합니다.
          </p>

          {/* SI */}
          <article id="biz-si" className="soft-card p-4 p-lg-5 mb-4">
            <div className="d-flex align-items-start gap-3 mb-3">
              <div className="biz-badge">
                <img
                  src={`${process.env.PUBLIC_URL}/icon/si.png`}
                  alt=""
                  aria-hidden="true"
                  className="biz-icon"
                />
              </div>
              <div>
                <h3 className="h4 fw-bold mb-1">System Integration</h3>
                <div className="text-secondary">정보화 전략 수립부터 통합 설계·구축·전환</div>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-12 col-lg-6">
                <ul className="biz-list">
                  <li><b>ISP/마스터플랜</b> — &nbsp; 정보화 전략·로드맵 수립</li>
                  <li><b>통합 아키텍처</b> — &nbsp; 요구분석 및 설계</li>
                  <li><b>맞춤형 시스템 구축</b> — &nbsp; 업무 특화 개발/구성</li>
                </ul>
              </div>
              <div className="col-12 col-lg-6">
                <ul className="biz-list">
                  <li><b>통합/전환</b> — &nbsp; H/W·S/W·DB 통합 및 전환</li>
                  <li><b>운영 표준</b> — &nbsp; 운영 표준 수립과 안정화 지원</li>
                  <li><b>유지보수</b> — &nbsp; 유지보수 및 기술 지원</li>
                </ul>
              </div>
            </div>
          </article>

          {/* Outsourcing */}
          <article id="biz-outsourcing" className="soft-card p-4 p-lg-5 mb-4">
            <div className="d-flex align-items-start gap-3 mb-3">
              <div className="biz-badge">
                <img
                  src={`${process.env.PUBLIC_URL}/icon/outsourcing.png`}
                  alt=""
                  aria-hidden="true"
                  className="biz-icon"
                />
              </div>
              <div>
                <h3 className="h4 fw-bold mb-1">Outsourcing</h3>
                <div className="text-secondary">전문 인력 기반의 운영 지원과 유지보수</div>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-12 col-lg-6">
                <ul className="biz-list">
                  <li><b>시스템 운영</b> — &nbsp; 시스템·네트워크·DB 운영 지원</li>
                  <li><b>보안 운영</b> — &nbsp; 보안 운영 및 점검</li>
                  <li><b>유지보수</b> — &nbsp; 패치·백업 등 기본 유지관리</li>
                </ul>
              </div>
              <div className="col-12 col-lg-6">
                <ul className="biz-list">
                  <li><b>지원 채널</b> — &nbsp; 헬프데스크·원격/현장 지원</li>
                  <li><b>구성/자산</b> — &nbsp; 문서·자산·구성 관리</li>
                  <li><b>정기 점검</b> — &nbsp; 정기 점검과 개선 제안</li>
                </ul>
              </div>
            </div>
          </article>

          {/* IT Consulting */}
          <article id="biz-consulting" className="soft-card p-4 p-lg-5 mb-4">
            <div className="d-flex align-items-start gap-3 mb-3">
              <div className="biz-badge">
                <img
                  src={`${process.env.PUBLIC_URL}/icon/itconsult.png`}
                  alt=""
                  aria-hidden="true"
                  className="biz-icon"
                />
              </div>
              <div>
                <h3 className="h4 fw-bold mb-1">IT Consulting</h3>
                <div className="text-secondary">전략·아키텍처·데이터·보안·클라우드 자문</div>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-12 col-lg-6">
                <ul className="biz-list">
                  <li><b>IT 전략/아키텍처</b> — &nbsp;전략·구조 자문</li>
                  <li><b>데이터 거버넌스</b> — &nbsp;표준·품질·메타 관리 자문</li>
                  <li><b>보안/개인정보</b> — &nbsp;체계·정책 자문</li>
                </ul>
              </div>
              <div className="col-12 col-lg-6">
                <ul className="biz-list">
                  <li><b>클라우드 전환</b> — &nbsp; 진단 및 계획 수립</li>
                  <li><b>PMO/품질</b> — &nbsp; 프로젝트 관리·품질 자문</li>
                  <li><b>교육/역량강화</b> — &nbsp; 내부 교육·가이드</li>
                </ul>
              </div>
            </div>
          </article>

          {/* 연구 · 장비 */}
          <article id="biz-lab" className="soft-card p-4 p-lg-5">
            <div className="d-flex align-items-start gap-3 mb-3">
              <div className="biz-badge">
                <img
                  src={`${process.env.PUBLIC_URL}/icon/tool.png`}
                  alt=""
                  aria-hidden="true"
                  className="biz-icon"
                />
              </div>
              <div>
                <h3 className="h4 fw-bold mb-1">연구 · 장비</h3>
                <div className="text-secondary">
                  AI·IoT 실증 연구와 테스트베드/장비 운영 — PoC 설계·성능평가·데이터 수집/계측·GPU/엣지 장비 운용
                </div>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-12 col-lg-6">
                <ul className="biz-list">
                  <li><b>실증/PoC 연구</b> — 문제정의, 데이터 수집 설계, 성과 지표 설계</li>
                  <li><b>시험·성능평가</b> — 부하/신뢰성/보안 테스트, 표준 절차 수립</li>
                  <li><b>데이터 수집 인프라</b> — 센서/게이트웨이/RTU 연동, 데이터 로거 구축</li>
                  <li><b>무향실</b> — 연구/교육기관의 전기·전자·통신제품 등 다양한 부품의 소음 측정 장비 구축</li>
                </ul>
              </div>
              <div className="col-12 col-lg-6">
                <ul className="biz-list">
                  <li><b>장비 운용</b> — GPU 서버/스토리지, 가상화·컨테이너(MLOps) 운영</li>
                  <li><b>드론/네트워크 장비</b> — 현장 촬영·스캐닝, 엣지 디바이스 셋업</li>
                  <li><b>렌탈/교육/유지보수</b> — 장비 대여·사용 교육, 정기 점검 및 기술 지원</li>
                  <li>
                    <b>3D 프린터</b>— 보급형부터 산업용, 금속 3D프린터까지 최고 품질과 전문성으로 3D프린팅 토탈 솔루션과 서비스를 제공
                  </li>
                </ul>
              </div>
            </div>
          </article>
        </div>
      </section>



      {/* 솔루션 (목록형, 좌우 교차 레이아웃) */}
      <section id="solutions" className="py-5 bg-light">
        <div className="container">
          <h2 className="h2 fw-bold mb-2">솔루션</h2>
          <p className="text-secondary mb-4 subTitle">
            산업별 니즈에 최적화된 솔루션을 한 번에 확인하세요.
          </p>

          <div className="sol-stack">
            {SOL_DETAILS.map((s, idx) => (
              <article
                key={s.key}
                className={`sol-card soft-card ${idx % 2 ? 'reverse' : ''}`}
              >
                {/* 미디어 */}
                <div className="sol-media">
                  <img src={s.img} alt={s.title} className="img-fluid" />
                </div>

                {/* 본문 */}
                <div className="sol-body">
                  <h3 className="h5 fw-bold mb-1">
                    {s.title} <small className="text-muted">{s.sub}</small>
                  </h3>
                  <p className="text-secondary">{s.summary}</p>

                  {s.badges?.length > 0 && (
                    <div className="d-flex flex-wrap gap-2 mb-2">
                      {s.badges.map((b, i) => (
                        <span key={i} className="badge text-bg-light border">
                          <img
                            src={`/icon/check.png`}
                            className='check-icon'
                            width={"15px"}
                            height={"15px"}
                            alt=""
                            aria-hidden="true"
                          />
                          {b}
                        </span>
                      ))}
                    </div>
                  )}

                  <div className="row g-3 sol-feature-rows">
                    <div className="col-12 col-md-6">
                      <div className="fw-semibold mb-1">특징</div>
                      <ul className="list-unstyled check-list mb-0">
                        {s.features.특징.map((li, i) => (
                          <li key={i}>{li}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="fw-semibold mb-1">주요 기능</div>
                      <ul className="list-unstyled dot-list mb-0">
                        {s.features.주요기능.map((li, i) => (
                          <li key={i}>{li}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>



      {/* 클라우드 (확장) */}
      <section id="cloud" className="py-5">
        <div className="container">

          {/* HERO 소개 */}
          <div className="cloud-hero soft-card p-4 p-lg-5">
            <div className="row align-items-center gy-4">
              <div className="col-12 col-lg-8">
                <div className="d-flex flex-wrap gap-2 mb-2">
                  <span className="cloud-badge">NHN</span>
                  <span className="cloud-badge">MSP</span>
                </div>

                {/* ▼▼▼ 여기에 '기존 사이트 - 클라우드 소개'의 문구를 그대로 넣어주세요 ▼▼▼ */}
                <h2 className="display-6 fw-bold mb-2">클라우드 전환·운영·최적화 원스톱</h2>
                <p className="text-secondary mb-3 subTitle">
                  성산씨엔에스는 클라우드 도입부터 운영·최적화까지 전 과정을 한 번에 지원합니다. <br/>
                  표준화된 프레임워크와 다년간의 구축/운영 경험을 바탕으로 안전하고 효율적인 클라우드 환경을 제공합니다.
                </p>
                <ul className="text-secondary mb-0">
                  <li>Landing Zone 설계 — 네트워크·계정 구조와 보안 기준 수립</li>
                  <li>마이그레이션/DR — 서버·DB·스토리지 이전 및 재해복구 구성</li>
                  <li>운영/MSP — 24×7 모니터링·알림·취약점 점검 및 IaC/SRE 기반 자동화</li>
                  <li>비용 최적화 — 사용량 분석, 리포팅, RI/Spot·스토리지 등 비용 절감</li>
                </ul>
                {/* ▲▲▲ */}
              </div>

              <div className="col-12 col-lg-3">
                <img src="/images/cloud.png" className="img-fluid" alt="cloud" />
              </div>
            </div>
          </div>

          {/* 순서도(Flow) – 단계 제목만 간결하게 노출 */}
          {(() => {
            const FLOW = [
              { key: 'plan',     title: '컨설팅/진단'     },
              { key: 'design',   title: '설계/보안'       },
              { key: 'migrate',  title: '마이그레이션'     },
              { key: 'operate',  title: '운영/MSP'        },
              { key: 'optimize', title: '비용/최적화'      },
            ];
            return (
              <>
                <h3 className="h5 fw-bold mt-4">도입 순서</h3>
                <div className="cloud-flow" role="list">
                  {FLOW.map((s, i) => (
                    <div className="flow-step" role="listitem" key={s.key}>
                      <div className="flow-node">{i + 1}</div>
                      <div className="flow-label">{s.title}</div>
                    </div>
                  ))}
                </div>
              </>
            );
          })()}

          {/* 상세 내용 – 기존 사이트 문구 그대로 배열에 입력 */}
          {(() => {
            const PHASES = [
              {
                title: '컴퓨팅 서비스',
                items: [
                  '필요에 따라 클라우드 가상 서버의 컴퓨팅 파워를 조정하여 서버 관리 없이 코드 실행 가능'
                ],
              },
              {
                title: '네트워킹',
                items: [
                  '글로벌 콘텐츠 전송 네트워크와 온프레미스에서 클라우드로의 전용 네트워크 연결 지원'
                ],
              },
              {
                title: '플랫폼 중심 클라우드',
                items: [
                  '인프라에 기반한 플랫폼 중심 클라우드 서비스를 제공합니다.'
                ],
              },
              {
                title: '데이터베이스',
                items: [
                  '높은 가용성과 보안이 적용된 Database 제공'
                ],
              },
              {
                title: '마이그레이션',
                items: [
                  '대규모 데이터세트 전송 및 데이터 마이그레이션 지원'
                ],
              },
              {
                title: 'API 관리',
                items: [
                  '애플리케이션 프로그래밍 인터페이스(API)를 관리하고 보호하는 서비스'
                ],
              },
              {
                title: '컨테이너 서비스',
                items: [
                  '완전 관리형 쿠버네티스 서비스와 컴퓨팅에 적합한 컨테이너 서비스 제공'
                ],
              },
              {
                title: '보안 서비스',
                items: [
                  '전문 기술 인력을 통한 보안 모니터링 및 운영 관리 지원'
                ],
              },
              {
                title: 'Managed Services',
                items: [
                  '클라우드 도입 컨설팅, 구축 운영/모니터링, 장애 대응 등 종합 관리 서비스 제공'
                ],
              },
              {
                title: '모니터링 서비스',
                items: [
                  'VM 자원 관리, 성능 및 로그 감시, 분석, 보고서 제공'
                ],
              },
              {
                title: 'CDN(Content Delivery Network)',
                items: [
                  '대용량 콘텐츠를 안정적으로 전달하는 스트리밍 서비스 제공'
                ],
              },
              {
                title: '부하 분산',
                items: [
                  '트래픽 집중을 막기 위한 부하 분산 기능 제공'
                ],
              },
            ];
            return (
              <>
                <h3 className="h5 fw-bold mt-4">상세 안내</h3>
                <div className="row g-3">
                  {PHASES.map((p, idx) => (
                    <div className="col-12 col-lg-3" key={idx}>
                      <div className="phase-card p-3 h-100">
                        <div className="phase-title">{p.title}</div>
                        <ul className="phase-list text-secondary mb-0">
                          {p.items.map((t, i) => <li key={i}>{t}</li>)}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            );
          })()}

          {/* CTA */}
          <div className="d-flex justify-content-center mt-4">
            <a href="#contact" className="btn btn-primary btn-lg rounded-pill">
              <img
                src={`/icon/inquire.png`}
                className="inquire-icon"
                width={"18px"}
                height={"auto"}
                alt=""
                aria-hidden="true"
              />클라우드 상담 요청
            </a>
          </div>
        </div>
      </section>



      {/* 공지 (게시판형) */}
      <section id="notice" className="py-5 bg-light">
        <div className="container">
          <h2 className="h2 fw-bold mb-4">공지사항</h2>
          <NoticeBoard />
        </div>
      </section>

      {/* 채용 */}
      <section id="recruit" className="py-5">
        <div className="container">
          <h2 className="h2 fw-bold mb-2">인재채용</h2>
          <p className="text-secondary mb-4 subTitle">성산씨엔에스와 함께 성장할 동료를 찾습니다.</p>

          <div className="row g-3">
            <div className="col-12 col-lg-4">
              <div className="soft-card p-3 h-100">
                <h3 className="h5">모집 분야</h3>
                <ul className=" text-secondary mb-0">
                  <li>JAVA 개발/.net 개발/C++</li>
                  <li>프로그램 개발자 (java/jsp/servlet)</li>
                  <li>데이터 엔지니어 / 분석</li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="soft-card p-3 h-100">
                <h3 className="h5">자격 요건</h3>
                <ul className=" text-secondary mb-0">
                  <li>초대졸이상 (졸업예정자 가능)</li>
                  <li>경력무관/개발 경험자 우대</li>
                  <li>개발 경험자 우대</li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="soft-card p-3 h-100 d-grid gap-2">
                <h3 className="h5">복지 / 환경</h3>
                <p className="text-secondary mb-0">유연근무 · 교육지원 · 프로젝트 성과 보상</p>
                <a className="btn btn-primary w-100 mt-2" href="#contact">
                  <img
                    src={`/icon/inquire.png`}
                    className="inquire-icon"
                    width={"18px"}
                    height={"auto"}
                    alt=""
                    aria-hidden="true"
                  />지원/문의
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 문의/오시는 길 */}
      <section id="contact" className="py-5 bg-light">
        <div className="container">
          <div className="row g-4">
            <div className="col-12 col-lg-6">
              <h2 className="h2 fw-bold mb-3">프로젝트 문의</h2>
              <form className="soft-card p-3" onSubmit={onSubmit}>
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label className="form-label">성함</label>
                    <input type="text" className="form-control" placeholder="홍길동"
                      value={userNm} onChange={(e)=> setUserNm(e.target.value)} />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label">회사명</label>
                    <input type="text" className="form-control" placeholder="성산씨엔에스"
                      value={comNm} onChange={(e)=> setComNm(e.target.value)} />
                  </div>
                  <div className="col-12">
                    <label className="form-label">이메일</label>
                    <input type="email" className="form-control" placeholder="you@example.com"
                      value={email} onChange={(e)=> setEmail(e.target.value)} />
                  </div>
                  <div className="col-12">
                    <label className="form-label">문의내용</label>
                    <textarea className="form-control" rows="4" placeholder="요구사항/일정/예산 등"
                      value={msg} onChange={(e)=> setMsg(e.target.value)} />
                  </div>
                  {/* 상태 메시지 */}
                  <div className="col-12">
                    {err && <div className="alert alert-danger py-2">{err}</div>}
                    {ok  && <div className="alert alert-success py-2">{ok}</div>}
                  </div>
                  <div className="col-12">
                    {/* 로그인 폼과 동일하게 submit 버튼 */}
                    <button type="submit" className="btn btn-primary btn-lg w-100" disabled={busy}>
                      {busy ? "전송 중..." : "문의 보내기"}
                    </button>
                  </div>

                </div>
              </form>
            </div>
            {/* 오른쪽: 지도 */}
            <div className="col-12 col-lg-6">
              <h2 className="h2 fw-bolder mb-3">오시는 길</h2>
              <div className="map-card soft-card p-0">
                <iframe
                  title="성산씨엔에스 오시는 길"
                  src={`https://www.google.com/maps?q=${
                    encodeURIComponent('전남광주통합특별시 서구 대남대로 465, 광주상공회의소 503호')
                  }&output=embed`}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  style={{ border: 0, width: '100%', height: '100%' }}
                  allowFullScreen
                />
                <div className="p-3 text-muted border-top">
                  TEL : 062-676-9960 · FAX : 062-676-4554 · 사업자등록번호 : 410-86-61800
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-5 border-top">
        <div className="container">
          <div className="row g-3 align-items-center">
            <div className="col-12 col-lg-8 small">
              <strong>SSCNS</strong> · (61981) 전남광주통합특별시 서구 대남대로 465 광주상공회의소 503호<br/>
              TEL : 062-676-9960 &nbsp; FAX : 062-676-4554 &nbsp; 사업자등록번호 : 410-86-61800<br/>
              ©2025 SSCNS ALL RIGHTS RESERVED
            </div>
            <div className="col-12 col-lg-4 text-lg-end small">
              <a className="me-3" href="#about">회사소개</a>
              <a className="me-3" href="#cloud">클라우드</a>
              <a href="#contact">문의</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<AppHome />} />
      {/* <Route path="/notice/:id" element={<NoticeDetail />} /> */}
      <Route path="/cms/*" element={<CmsApp />} />
    </Routes>
  );
}
